import React from 'react';
export function TimelineSection() {
  const weeks = [{
    week: 'Semana 1',
    title: 'Desinflamación',
    desc: 'Adaptación inicial. Tu cuerpo empieza a soltar la retención de líquidos.'
  }, {
    week: 'Semana 2',
    title: 'Energía',
    desc: 'Mejor saciedad y niveles de energía más estables durante el día.'
  }, {
    week: 'Semana 3',
    title: 'Resultados',
    desc: 'Cambios visibles en cómo te queda la ropa y medidas corporales.'
  }];
  return <section className="py-20 bg-white" data-id="element-169">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-170">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-center text-[#3D4852] mb-16" data-id="element-171">
          Qué esperar en 21 días
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-172">
          {weeks.map((week, index) => <div key={index} className="relative group" data-id="element-173">
              <div className="absolute inset-0 bg-[#C17F6B] rounded-2xl transform rotate-3 opacity-10 group-hover:rotate-6 transition-transform" data-id="element-174"></div>
              <div className="relative bg-white p-8 rounded-2xl border border-gray-100 shadow-lg h-full" data-id="element-175">
                <span className="inline-block px-3 py-1 bg-[#3D4852] text-white text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-176">
                  {week.week}
                </span>
                <h3 className="text-2xl font-serif font-bold text-[#C17F6B] mb-3" data-id="element-177">
                  {week.title}
                </h3>
                <p className="text-gray-600" data-id="element-178">{week.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}